/**
 * Pictograma "assembly point" (ISO 7010 E007) como STRING — setas convergindo
 * dos 4 cantos para um grupo de pessoas (símbolo quase universal de ponto de
 * encontro/reunião de emergência).
 *
 * Fonte ÚNICA do desenho, compartilhada pelo componente React `AssemblyPointIcon`
 * (painel/legenda/popup) e por contextos NÃO-React (ex.: `L.divIcon` do Leaflet no
 * MapOverlays), sem depender de `react-dom/server`. Fica num `.ts` puro para o
 * `.tsx` do ícone exportar só o componente (Fast Refresh).
 */

/**
 * Sanitiza a cor antes de interpolar no markup cru (defesa contra XSS, já que este
 * SVG é injetado via `dangerouslySetInnerHTML`/`L.divIcon.html`). Aceita só hex
 * (`#rgb`..`#rrggbbaa`), `currentColor` ou nome de cor CSS (letras); qualquer coisa
 * com aspas/tags/espaço cai no fallback seguro. Hoje todos os call-sites passam
 * constantes, mas o guard impede regressão futura.
 */
function safeColor(color: string): string {
  return /^(#[0-9a-fA-F]{3,8}|[a-zA-Z]+)$/.test(color) ? color : 'currentColor';
}

/** Setas + figuras (sem a tag <svg>), parametrizado pela cor (sanitizada). */
export function innerSvg(rawColor: string): string {
  const color = safeColor(rawColor);
  const arrows = [0, 90, 180, 270]
    .map(
      (deg) =>
        `<g transform="rotate(${deg} 12 12)"><path d="M2.8 2.8 L6.9 6.9"/>` +
        `<path d="M6.9 4.2 L6.9 6.9 L4.2 6.9"/></g>`,
    )
    .join('');
  return (
    `<g fill="none" stroke="${color}" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${arrows}</g>` +
    `<g fill="${color}"><circle cx="12" cy="9.6" r="1.75"/>` +
    `<path d="M12 11.7c-2.05 0-3.05 1.55-3.05 3.7V16.1h1.2l.4 2.5h2.9l.4-2.5h1.2v-.7c0-2.15-1-3.7-3.05-3.7z"/></g>`
  );
}

/** SVG completo como STRING — para contextos não-React (ex.: `L.divIcon` do Leaflet). */
export function assemblyPointSvgString(color: string, size: number): string {
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" ` +
    `viewBox="0 0 24 24" aria-hidden="true">${innerSvg(color)}</svg>`
  );
}
